import { createEvent } from 'effector';

export const addImage = createEvent<{ imageId: string; value: string }>();

export const deleteImage = createEvent<{ imageId: string }>();
